export default "__VITE_ASSET__C_ChtHhM__"